// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	//cms form animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}

	//burger menu functionality
	const burgerMenuBtn = document.querySelector('[data-burgeropen]');
	const burgerMenuClose = document.querySelector('[data-burgerclose]');
	const burgerMenu = document.querySelector('[data-burgermenu]');

	if(burgerMenu) {
		burgerMenuBtn.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.add('open');
			document.body.classList.add('no-scroll');
		});

		burgerMenuClose.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.remove('open');
			document.body.classList.remove('no-scroll');
		});

		document.getElementById("primary-nav").addEventListener("click", (e) => {
			let target = e.target.closest("li");
	
			if (!target)
				return;
	
			target.classList.toggle("active");
		});
	}

	//PARALLAX ANIMATION 

	let scrollParallax = []
	let scrolled = 0
	let v_height = window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight;

	function doParallax(elm) {
		let boundes = elm.dataset.parallax.split(",") 
		let distance = Math.abs(boundes[0] - boundes[1])
		if (boundes[0] > boundes[1]) {
			distance = distance * -1
		}
		const unit_scroll = distance / (v_height + elm.offsetHeight)
		let temp = 0
		let topElement = 0;
		let element = elm;
		let id_elem = elm.dataset.parallaxid
		do {
			topElement += element.offsetTop || 0;
			element = element.offsetParent;
		} while (element)
		let parallaxFunction = function () {
			scrolled = document.documentElement.scrollTop || window.pageYOffset
			let relative_distance = scrolled + v_height - topElement
			temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
			elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
		}
		scrollParallax[id_elem] = parallaxFunction
		window.addEventListener('scroll', scrollParallax[id_elem])
	}

	let observers_parallax = document.querySelectorAll(".js-parallax-element")

	if (observers_parallax) {
		let options_parallax = {
			root: null,
			rootMargin: '0px',
			threshold: 0
		}

		function handler_parallax(entries, observer) {
			let entry;
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					doParallax(entry.target)
				} else {
					let id_elem = entry.target.dataset.parallaxid
					window.removeEventListener('scroll', scrollParallax[id_elem])
				}
			})
		}

		let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
		let counter = 1
		observers_parallax.forEach(function (element) {
			observable_parallax.observe(element)
			element.dataset.parallaxid = counter
			counter++
		})
	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
		  header.classList.add('down');
		  header.classList.remove('up');
		} else {
		  header.classList.add('up');
		  header.classList.remove('down');
		}
	} else {
		header.classList.remove('up', 'down');
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}